<template>
  <vc-share-a :class="$style.ogpLink" :href="url" target="_self">
    <div :class="$style.image">
      <v-img :src="imageUrl" :width="90" :height="90"></v-img>
    </div>
    <div :class="$style.content">
      <div :class="$style.title">{{ title }}</div>
      <div
        :class="[
          $style.description,
          $vuetify.breakpoint.xs ? $style.description__xs : ''
        ]"
      >
        {{ description }}
      </div>
      <div :class="$style.url">{{ host }}</div>
    </div>
  </vc-share-a>
</template>

<script>
export default {
  name: "vc-share-ogp",
  props: {
    url: {
      type: String,
      default: ""
    },
    imageUrl: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    host: {
      type: String,
      default: ""
    }
  }
};
</script>

<style module>
.ogpLink {
  display: block;
  position: relative;

  width: 100%;

  background-color: #ffffff;
  border-color: #e0e0e0;
  border-style: solid;
  border-width: 1px 1px 1px 1px;

  color: #000000;
  text-decoration: none;

  margin-bottom: 10px;
}

.ogpLink:hover,
.ogpLink:active,
.ogpLink:focus {
  text-decoration: none;
}

.ogpLink:hover .image {
  opacity: 0.4;
}
.ogpLink:hover div {
  color: #a0a0a0;
}

.image {
  position: absolute;
  left: 0;
  top: 0;
  width: 90px;
  height: 90px;
}

.content {
  height: 90px;
  vertical-align: top;
  padding: 5px 5px 0 95px;
}

.title {
  font-weight: bold;
  height: 1.42em;
  overflow: hidden;
  height: 1.42 * 3em;
}

.description {
  font-size: 12px;
  height: calc(1.42 * 2em);
  overflow: hidden;
}

.description__xs {
  visibility: hidden;
}

.url {
  font-size: 12px;
  height: 1.42em;
  overflow: hidden;
  margin-top: 5px;
  color: #808080;
}
</style>
